import { render, staticRenderFns } from "./DocInvoices.vue?vue&type=template&id=f05fc3ee&"
import script from "./DocInvoices.vue?vue&type=script&lang=js&"
export * from "./DocInvoices.vue?vue&type=script&lang=js&"
import style0 from "./DocInvoices.vue?vue&type=style&index=0&id=f05fc3ee&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports